{{message}}
<button (click)="paynow()">Pay Now</button>